// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__32uIV","actionsCol":"EnrolledClinics_actionsCol__3ZxFp"};